import React from "react";
import "./TrustedTechnologies.css";

import {
  FaReact,
  FaNodeJs,
  FaDocker,
  FaAws,
} from "react-icons/fa";

import {
  SiNextdotjs,
  SiFastapi,
  SiPostgresql,
  SiMongodb,
  SiRedis,
  SiTensorflow,
} from "react-icons/si";

const technologies = [

  {
    icon: <FaReact />,
    title: "React.js",
    desc: "Modern scalable frontend applications",
  },

  {
    icon: <SiNextdotjs />,
    title: "Next.js",
    desc: "SEO-friendly enterprise web platforms",
  },

  {
    icon: <SiFastapi />,
    title: "FastAPI",
    desc: "High-performance backend architecture",
  },

  {
    icon: <FaNodeJs />,
    title: "Node.js",
    desc: "Realtime APIs and scalable systems",
  },

  {
    icon: <SiPostgresql />,
    title: "PostgreSQL",
    desc: "Enterprise-grade relational databases",
  },

  {
    icon: <SiMongodb />,
    title: "MongoDB",
    desc: "Flexible NoSQL application databases",
  },

  {
    icon: <FaDocker />,
    title: "Docker",
    desc: "Containerized deployment infrastructure",
  },

  {
    icon: <FaAws />,
    title: "AWS",
    desc: "Cloud-native scalable architecture",
  },

  {
    icon: <SiRedis />,
    title: "Redis",
    desc: "Caching and realtime queue systems",
  },

  {
    icon: <SiTensorflow />,
    title: "TensorFlow",
    desc: "AI and machine learning systems",
  },

];

const TrustedTechnologies = () => {

  return (

    <section className="trusted-tech-section">

      <div className="trusted-tech-container">

        {/* SECTION HEADER */}
        <div className="trusted-tech-header">

          <p className="trusted-tech-label">
            TECHNOLOGY STACK
          </p>

          <h2 className="trusted-tech-title">
            Technologies We Use
          </h2>

          <p className="trusted-tech-description">

            We build enterprise-grade software systems
            using modern frontend, backend, cloud and AI
            technologies optimized for scalability,
            performance and long-term growth.

          </p>

        </div>

        {/* TECHNOLOGY GRID */}
        <div className="trusted-tech-grid">

          {technologies.map((tech, index) => (

            <div
              className="tech-card"
              key={index}
            >

              <div className="tech-icon">
                {tech.icon}
              </div>

              <h3>
                {tech.title}
              </h3>

              <p>
                {tech.desc}
              </p>

            </div>

          ))}

        </div>

      </div>

    </section>

  );

};

export default TrustedTechnologies;